import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const MAANDEN = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec'];
const EMOJI_SETS = [
  { groep: 'Halloween',  lijst: ['🎃','👻','🕸️','🕷️','🦇','🍂','💀','🧙','🧛','🧟','🪦','🍬'] },
  { groep: 'Kerst',      lijst: ['🎄','❄️','⛄','🎅','🤶','🦌','⭐','🎁','🔔','🕯️','🧦','☃️'] },
  { groep: 'Sinterklaas',lijst: ['🎁','👴','🐴','⛵','🍬','📜','🎩'] },
  { groep: 'Nieuwjaar',  lijst: ['🎆','🎇','🥂','🍾','🎉','🎊','⏰','🥳'] },
  { groep: 'Koningsdag', lijst: ['👑','🧡','🎈','🇳🇱','🍊','🎪','🎺'] },
  { groep: 'Valentijn',  lijst: ['❤️','💘','💝','🌹','💕','😍','💌'] },
  { groep: 'Pasen/Lente',lijst: ['🌷','🐣','🐰','🥚','💐','🌸','🦋','🌱'] },
  { groep: 'Zomer',      lijst: ['☀️','🏖️','🌊','🍦','😎','🌴','🩴','⛱️'] },
  { groep: 'Herfst',     lijst: ['🍂','🍁','🌰','🍄','🌧️','☂️','🦔'] },
  { groep: 'Winter',     lijst: ['❄️','⛄','🧣','🧤','🔥','🌨️','⛸️'] },
  { groep: 'Weer',       lijst: ['🌈','⛈️','🌪️','⚡','☁️','🌙','⭐','🌞'] },
  { groep: 'Feest',      lijst: ['🥳','🎊','🎉','🎈','🎆','🎇','✨','🏆','🍰','🎂'] },
  { groep: 'Werk / S&T', lijst: ['🚋','🔧','⚡','🛤️','🚧','🔌','🛠️','⚙️','🚆','🚇'] },
  { groep: 'Sport',      lijst: ['⚽','🏆','🥇','🎯','🏅','🚴','🏃'] },
  { groep: 'Eten',       lijst: ['🍕','🍟','☕','🍺','🍻','🌭','🥨','🍩'] },
  { groep: 'Diversen',   lijst: ['🎵','🎸','🔥','💪','🎯','👍','💯','🚀','💡','🧡'] },
]
const leeg = { naam: '', van_dag: 1, van_maand: 10, tot_dag: 31, tot_maand: 10, accent: '#F97316', accent2: '#7C3AED', emojis: '', effect: 'zweef', effect_emoji: '👻', actief: true, interval_sec: 8 };
const input = { width: '100%', padding: '9px 11px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };
const btnP = { padding: '10px 18px', borderRadius: 8, border: 'none', background: '#2563eb', color: 'white', fontWeight: 600, fontSize: 14, cursor: 'pointer' };

export default function ThemaBeheer() {
  const navigate = useNavigate();
  const [themas, setThemas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(null); // null | 'new' | id
  const [form, setForm] = useState(leeg);
  const [bezig, setBezig] = useState(false);
  const [mijnVoorkeur, setMijnVoorkeur] = useState(true);
  useEffect(() => { api.get('/themas/mijn-voorkeur').then(r => setMijnVoorkeur(r.data?.zichtbaar !== false)).catch(()=>{}); }, []);
  const zetAan = async () => { try { await api.post('/themas/mijn-voorkeur', { zichtbaar: true }); setMijnVoorkeur(true); alert('Thema\'s weer aan voor jouw account (ververs de pagina).'); } catch(e){} };

  const laad = async () => {
    setLoading(true);
    try { const r = await api.get('/themas'); setThemas(r.data.themas || []); } catch (e) {}
    setLoading(false);
  };
  useEffect(() => { laad(); }, []);

  const nieuw = () => { setForm({ ...leeg }); setEdit('new'); };
  const bewerk = (t) => {
    setForm({
      naam: t.naam, van_dag: t.van_dag, van_maand: t.van_maand, tot_dag: t.tot_dag, tot_maand: t.tot_maand,
      accent: t.accent || '#F97316', accent2: t.accent2 || '#7C3AED', emojis: t.emojis || '',
      effect: t.effect || 'geen', effect_emoji: t.effect_emoji || '', actief: t.actief !== false, interval_sec: t.interval_sec || 8
    });
    setEdit(t.id);
  };
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const opslaan = async () => {
    if (!form.naam.trim()) { alert('Geef het thema een naam'); return; }
    setBezig(true);
    try {
      if (edit === 'new') await api.post('/themas', form);
      else await api.put('/themas/' + edit, form);
      setEdit(null); laad();
    } catch (e) { alert('Opslaan mislukt: ' + (e.response?.data?.message || e.message)); }
    setBezig(false);
  };
  const verwijder = async (t) => {
    if (!window.confirm('Thema "' + t.naam + '" verwijderen?')) return;
    try { await api.delete('/themas/' + t.id); laad(); }
    catch (e) { alert(e.response?.data?.message || 'Verwijderen mislukt (platform-thema kan niet weg)'); }
  };
  const toggleActief = async (t) => {
    // optimistisch: meteen in de lijst omzetten, dan pas server
    setThemas(prev => prev.map(x => x.id === t.id ? { ...x, actief: !x.actief } : x));
    try { await api.put('/themas/' + t.id + '/toggle'); }
    catch (e) {
      setThemas(prev => prev.map(x => x.id === t.id ? { ...x, actief: t.actief } : x)); // terugdraaien bij fout
      alert(e.response?.data?.message || 'Aan/uit zetten mislukt');
    }
  };

  // ---- Editor ----
  if (edit !== null) {
    const emojisArr = (form.emojis || '').trim().split(/\s+/).filter(Boolean);
    return (
      <div style={{ padding: 24, maxWidth: 640, margin: '0 auto' }}>
        <button onClick={() => setEdit(null)} style={{ background: '#f1f5f9', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', marginBottom: 16 }}>&larr; Terug</button>
        <h1 style={{ fontSize: 24, margin: '0 0 4px' }}>🎨 {edit === 'new' ? 'Nieuw thema' : 'Thema bewerken'}</h1>
        <p style={{ color: '#6b7280', marginTop: 0, fontSize: 14 }}>Emoji's plak je met Windows-toets + . (punt).</p>

        <div style={{ background: 'white', borderRadius: 12, padding: 18, border: '1px solid #e5e7eb', display: 'grid', gap: 14 }}>
          <div>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Naam</label>
            <input value={form.naam} onChange={e => set('naam', e.target.value)} placeholder="bijv. Halloween" style={{ ...input, marginTop: 4 }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Van (dag / maand)</label>
              <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                <input type="number" min="1" max="31" value={form.van_dag} onChange={e => set('van_dag', +e.target.value)} style={{ ...input, width: 70 }} />
                <select value={form.van_maand} onChange={e => set('van_maand', +e.target.value)} style={input}>
                  {MAANDEN.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                </select>
              </div>
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Tot (dag / maand)</label>
              <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                <input type="number" min="1" max="31" value={form.tot_dag} onChange={e => set('tot_dag', +e.target.value)} style={{ ...input, width: 70 }} />
                <select value={form.tot_maand} onChange={e => set('tot_maand', +e.target.value)} style={input}>
                  {MAANDEN.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                </select>
              </div>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Kleur 1</label>
              <input type="color" value={form.accent} onChange={e => set('accent', e.target.value)} style={{ ...input, height: 42, padding: 4, marginTop: 4 }} />
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Kleur 2</label>
              <input type="color" value={form.accent2} onChange={e => set('accent2', e.target.value)} style={{ ...input, height: 42, padding: 4, marginTop: 4 }} />
            </div>
          </div>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Emoji's (klik om toe te voegen, of typ zelf)</label>
            <input value={form.emojis} onChange={e => set('emojis', e.target.value)} placeholder="🎃 👻 🕸️" style={{ ...input, marginTop: 4, fontSize: 18 }} />
            <div style={{ marginTop: 8, display: 'grid', gap: 6 }}>
              {EMOJI_SETS.map(s => (
                <div key={s.groep} style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 11, color: '#94a3b8', minWidth: 70 }}>{s.groep}</span>
                  {s.lijst.map(em => (
                    <button key={em} type="button"
                      onClick={() => set('emojis', ((form.emojis || '').trim() + ' ' + em).trim())}
                      style={{ fontSize: 20, border: '1px solid #e5e7eb', borderRadius: 8, background: 'white', cursor: 'pointer', padding: '2px 6px', lineHeight: 1 }}>
                      {em}
                    </button>
                  ))}
                </div>
              ))}
              {form.emojis && (
                <button type="button" onClick={() => set('emojis', '')}
                  style={{ alignSelf: 'start', fontSize: 12, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer', padding: '2px 0' }}>
                  ✕ leegmaken
                </button>
              )}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Effect</label>
              <select value={form.effect} onChange={e => set('effect', e.target.value)} style={{ ...input, marginTop: 4 }}>
                <option value="geen">Geen</option>
                <option value="zweef">Zweven (van links naar rechts)</option>
                <option value="sneeuw">Vallen (van boven naar beneden)</option>
              </select>
            </div>
            <div>
              <label style={{ fontSize: 13, fontWeight: 600 }}>Welk emoji zweeft/valt?</label>
              <input value={form.effect_emoji} onChange={e => set('effect_emoji', e.target.value)} placeholder="👻" style={{ ...input, marginTop: 4, fontSize: 18 }} />
              <div style={{ marginTop: 6, display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                {['👻','❄️','🍂','🍁','🎈','🌸','⭐','🦇','🔔','✨','🌧️','🎊','💐','🧡','🎃','🦋','🍬','🥂'].map(em => (
                  <button key={em} type="button" onClick={() => set('effect_emoji', em)}
                    style={{ fontSize: 18, border: '1px solid #e5e7eb', borderRadius: 6, background: form.effect_emoji === em ? '#eff6ff' : 'white', cursor: 'pointer', padding: '1px 5px', lineHeight: 1 }}>
                    {em}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Elke hoeveel seconden een emoji? ({form.interval_sec}s)</label>
            <input type="range" min="2" max="30" value={form.interval_sec} onChange={e => set('interval_sec', +e.target.value)} style={{ width: '100%', marginTop: 6 }} />
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#94a3b8' }}><span>druk (2s)</span><span>rustig (30s)</span></div>
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 600 }}>
            <input type="checkbox" checked={form.actief} onChange={e => set('actief', e.target.checked)} style={{ width: 18, height: 18 }} />
            Actief (thema doet mee in zijn periode)
          </label>

          {/* Live voorbeeld */}
          <div style={{ borderRadius: 10, padding: 14, background: '#0f172a', color: 'white', position: 'relative', overflow: 'hidden', minHeight: 60 }}>
            <div style={{ fontSize: 12, opacity: 0.6, marginBottom: 6 }}>Voorbeeld:</div>
            <div style={{ fontSize: 22 }}>{emojisArr.join(' ')} {form.effect_emoji}</div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <span style={{ padding: '4px 12px', borderRadius: 6, background: form.accent, fontSize: 13, fontWeight: 600 }}>kleur 1</span>
              <span style={{ padding: '4px 12px', borderRadius: 6, background: form.accent2, fontSize: 13, fontWeight: 600 }}>kleur 2</span>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
          <button onClick={() => setEdit(null)} style={{ padding: '10px 18px', borderRadius: 8, border: '1px solid #d1d5db', background: 'white', cursor: 'pointer' }}>Annuleren</button>
          <button onClick={opslaan} disabled={bezig} style={{ ...btnP, opacity: bezig ? 0.6 : 1 }}>{bezig ? 'Opslaan…' : '💾 Thema opslaan'}</button>
        </div>
      </div>
    );
  }

  // ---- Lijst ----
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <h1 style={{ margin: 0, fontSize: 28 }}>🎨 Thema-beheer</h1>
        <button onClick={nieuw} style={btnP}>+ Nieuw thema</button>
      </div>
      <p style={{ color: '#6b7280', marginTop: 0 }}>Seizoensthema's die automatisch aangaan in hun periode (Halloween 🎃, Kerst 🎄, …). Platform-thema's kun je aan/uit zetten maar niet bewerken/verwijderen.</p>
      {!mijnVoorkeur && (
        <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 10, padding: '10px 14px', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 14, color: '#92400e' }}>🎃 Thema-effecten staan UIT voor jouw account.</span>
          <button onClick={zetAan} style={{ background: '#f59e0b', color: 'white', border: 'none', borderRadius: 8, padding: '6px 14px', fontWeight: 600, cursor: 'pointer' }}>Weer aanzetten</button>
        </div>
      )}

      {loading ? <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Laden…</div>
        : themas.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', background: 'white', borderRadius: 12, border: '1px solid #e5e7eb' }}>Nog geen thema's.</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }}>
            {themas.map(t => {
              const platform = t.bedrijf_id === null;
              return (
                <div key={t.id} style={{ background: 'white', borderRadius: 12, padding: 16, border: '1px solid #e5e7eb', borderLeft: '4px solid ' + (t.accent || '#94a3b8') }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 8 }}>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: 16 }}>{t.emojis ? (t.emojis.trim().split(/\s+/)[0] + ' ') : ''}{t.naam}</div>
                      <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                        {t.van_dag} {MAANDEN[t.van_maand - 1]} – {t.tot_dag} {MAANDEN[t.tot_maand - 1]}
                        {platform && <span style={{ marginLeft: 6, background: '#eff6ff', color: '#2563eb', padding: '1px 6px', borderRadius: 6, fontSize: 11 }}>platform</span>}
                      </div>
                    </div>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, cursor: 'pointer' }}>
                      <input type="checkbox" checked={t.actief} onChange={() => toggleActief(t)} style={{ width: 16, height: 16 }} />
                      aan
                    </label>
                  </div>
                  <div style={{ fontSize: 18, marginTop: 8 }}>{t.emojis} {t.effect_emoji}</div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                    <button onClick={() => bewerk(t)} style={{ flex: 1, padding: 8, background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>Bewerken</button>
                    {!platform && (
                      <button onClick={() => verwijder(t)} style={{ padding: '8px 12px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, cursor: 'pointer' }}>🗑️</button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
    </div>
  );
}
